<template>
  <div class="marginator">
    <div class="pre-trade">
      <div class="head-main preparation">
        <div class="head-content">
          <v-icon color="#4dbac0">hourglass_empty</v-icon>
          <b>New Trade Preparation</b>
        </div>
        <div class="prepare-action">
          <v-btn
            v-if="!prepareExists"
            :disabled="ready"
            @click="newPrepare"
            small
            class="white--text text-capitalize"
            color="#79c04d"
          >
            Inititate
            <v-icon>note_add</v-icon>
          </v-btn>
          <v-btn
            :disabled="freeze"
            v-else
            @click="closePrepare('closed')"
            small
            class="white--text text-capitalize"
            color="#E62163"
          >
            Cancel
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <div v-if="$vuetify.breakpoint.smAndUp" class="my-row-small mr-2">
          <v-select
            v-if="!prepareExists"
            v-model="selectedTIF"
            :items="timeInForce"
            background-color="#404855"
            solo
            flat
            prepend-inner-icon="timelapse"
          ></v-select>
          <v-select
            v-else
            disabled
            :placeholder="!freeze ? remain : countDown"
            background-color="#404855"
            solo
            flat
            class="disabled-white"
            prepend-inner-icon="timelapse"
          ></v-select>
        </div>
      </div>

      <div class="prep-body inpmargin-top px-4">
        <div v-if="$vuetify.breakpoint.xs" class>
          <v-select
            v-if="!prepareExists"
            v-model="selectedTIF"
            :items="timeInForce"
            background-color="#404855"
            solo
            flat
            prepend-inner-icon="timelapse"
          ></v-select>
          <v-select
            v-else
            disabled
            :placeholder="remain"
            background-color="#404855"
            solo
            class="disabled-white"
            flat
            prepend-inner-icon="timelapse"
          ></v-select>

          <v-select
            :disabled="prepareExists ? true : false"
            v-model="selectedSymbol"
            placeholder="* Market"
            :items="userMarkets"
            label="Market..."
            background-color="#404855"
            itemText="user"
            return-object
            solo
            flat
            class="my-vselect"
          ></v-select>

          <div class="descpInput mb-5">
            <input
              v-model="selectedPrice"
              placeholder="Price"
              type="text"
              name="newPost"
              autocomplete="off"
            />
          </div>

          <v-select
            v-model="selectedType"
            :items="type"
            background-color="#404855"
            solo
            flat
            class="width-full"
          >
            <template v-slot:selection="data">
              <span v-bind:class="[data.item == 'Long' ? 'long' : 'short']">{{ data.item }}</span>
            </template>
            <template v-slot:item="data">
              <span v-bind:class="[data.item == 'Long' ? 'long' : 'short']">{{ data.item }}</span>
            </template>
          </v-select>

          <v-select
            v-model="selectedStrategy"
            placeholder="* Strategy"
            :items="userStrategies"
            itemText="name"
            background-color="#404855"
            return-object
            solo
            flat
          ></v-select>
        </div>

        <div v-if="$vuetify.breakpoint.smAndUp" class>
          <div class="minwidth">
            <div class="my-row inpmargin-right">
              <v-select
                :disabled="prepareExists ? true : false"
                v-model="selectedSymbol"
                :items="userMarkets"
                background-color="#404855"
                itemText="user"
                return-object
                solo
                placeholder="* Market"
                flat
                class="my-vselect"
              ></v-select>
            </div>

            <div class="my-row inpmargin-right">
              <div class="descpInput">
                <input
                  v-model="selectedPrice"
                  type="text"
                  name="newPost"
                  placeholder="Price"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>

          <div class="minwidth">
            <div class="my-row inpmargin-right">
              <v-select
                :disabled="prepareExists ? true : false"
                placeholder="* Strategy"
                v-model="selectedStrategy"
                :items="userStrategies"
                itemText="name"
                background-color="#404855"
                return-object
                solo
                flat
              ></v-select>
            </div>
            <div class="my-row">
              <v-select
                :disabled="prepareExists ? true : false"
                placeholder="Type"
                v-model="selectedType"
                :items="type"
                background-color="#404855"
                solo
                flat
              >
                <template v-slot:selection="data">
                  <span v-bind:class="[data.item == 'Long' ? 'long' : 'short']">{{ data.item }}</span>
                </template>
                <template v-slot:item="data">
                  <span v-bind:class="[data.item == 'Long' ? 'long' : 'short']">{{ data.item }}</span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div>
          <transition name="fade">
            <div v-if="checklist">
              <div v-if="checklist.length > 0">
                <div class="mb-2">Strategy Checklist</div>

                <v-chip
                  v-for="(check,index) in checklist"
                  :key="check._id"
                  :color="check.selected ? '#4dbac0' : '' "
                  class="float-left mr-2 pointer"
                  @click="selectChecklist(index)"
                >
                  <v-avatar left>
                    <v-icon size="18" v-if="check.selected">check_box</v-icon>
                    <v-icon size="18" v-else>check_box_outline_blank</v-icon>
                  </v-avatar>
                  {{check.name}}
                </v-chip>
              </div>
            </div>
          </transition>
        </div>

        <div class="prep-body tag-chip mt-4">
          <v-select
            v-model="selectedTags"
            :items="filteredTags"
            itemText="name"
            label="Additional Trade Tags..."
            color="#4dbac0"
            multiple
            chips
            return-object
            autocomplete="off"
            :menu-props="{ bottom: true, offsetY: true }"
            deletable-chips
          ></v-select>
        </div>
        <div v-if="uploading">
          <v-progress-linear indeterminate value="0"></v-progress-linear>
        </div>
        <!--
        <TextInput v-if="!prepareExists"
            :size="1"
            placeholder="Additional comment..."
            @imgData="imgData"
            @textData="textData"
            @sending="sendMessage"
            :reset="textInputReset"
          />
          <div class="width-full float-left mt-3 text-font" v-else>
            <div class="mb-3">{{prepareExists.description}}</div>
            <div v-if="prepareExists._images.length > 0">
              <vue-picture-swipe :items="prepareExists._images"></vue-picture-swipe>
            </div>
          </div>
        -->
      </div>
      <!--<TextInput parentId="12345" parentType="Strategies" storeKey="StrategyDetail" /> -->
    </div>

    <div class="mt-4 float-left">
      <span class="text-submenu">Timeline</span>
      <div class="pre-trade mt-2">
        <PoolTimeline />
      </div>
    </div>

    <div class="history mt-4">
      <span v-if="history" class="text-submenu">Preparation History</span>
      <div class="mt-2">
        <transition-group name="list">
          <PreTradeRecord v-for="record in history" :key="record._id" :record="record"></PreTradeRecord>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import PoolTimeline from "@/components/PoolTimeline/";
var moment = require("moment");
import PreTradeRecord from "./item.vue";
import axios from "axios";
axios.defaults.headers.common["Authorization"] = `Token ${localStorage.getItem(
  "access_token"
)}`;
export default {
  name: "TradePreparation",
  components: {
    PoolTimeline,
    PreTradeRecord
  },

  data() {
    return {
      type: ["Long", "Short"],
      timeInForce: [
        "End of Day",
        "1 Hour",
        "15 Minutes",
        "5 Minutes",
        "Till Cancel"
      ],

      freeze: false,
      countDown: 10,

      selectedTIF: "End of Day",
      selectedPrice: null,
      selectedSymbol: null,
      selectedStrategy: null,
      selectedTags: null,
      selectedType: "Long",
      description: null,
      images: [],

      checklist: [],

      userStrategies: null,
      userTags: null,
      filteredTags: null,
      userMarkets: null,
      prepareExists: null,

      history: null,
      remain: null,
      debug: null,
      uploading: false
    };
  },

  watch: {
    selectedStrategy: function(newVal) {
      //if (!this.prepareExists) {
      //alert("change");
      axios
        .post("https://tradeinpool.com:3001/api/request/checklist/", {
          id: newVal._id
        })
        .then(response => {
          this.debug = response.data;
          if (response.data._checkList.length > 0) {
            if (!this.prepareExists) {
              this.checklist = response.data._checkList;

              if (this.checklist) {
                this.checklist.forEach(check => {
                  check.selected = false;
                });
              }
            }

            this.filteredTags = this.userTags;
            this.filteredTags = [];
            if (this.userTags) {
              this.userTags.forEach(element => {
                this.filteredTags.push(element);
              });
            }

            this.checklist.forEach(check => {
              for (var i = 0; i < this.filteredTags.length; i++) {
                if (this.filteredTags[i].name === check.name) {
                  this.filteredTags.splice(i, 1);
                  i--;
                  break;
                }
              }
            });
          } else {
            this.checklist = null;
            this.filteredTags = [];
            if (this.userTags) {
              this.userTags.forEach(element => {
                this.filteredTags.push(element);
              });
            }
          }
        });
      //}
    },
    selectedTags: function(newVal) {
      if (this.prepareExists) {
        var prepareData = {
          method: "update",
          id: this.prepareExists._id,
          key: "tags",
          new: newVal
        };
        axios
          .post(
            "https://tradeinpool.com:3001/api/update/TradePreparation/",
            prepareData
          )
          .then(() => {});
      }
    }
  },

  computed: {
    ready() {
      if (this.selectedSymbol && this.selectedStrategy) return false;
      else return true;
    }
  },

  async mounted() {
    /*
    this.sockets.subscribe("PREPARE_CLOSE", data => {
      this.history.unshift(data);
      if (this.history.length > 5) this.history.pop();
    });

    this.sockets.unsubscribe('PREPARE_CLOSEs');
*/
    await this.getTags();
    await this.getStrategies();
    await this.getMarkets();
    await this.getCurrent();
    await this.getHistory();
    if (this.prepareExists) {
      this.selectedSymbol = this.prepareExists.symbol;
      this.selectedStrategy = this.prepareExists._strategy;
      this.selectedTags = this.prepareExists.tags;
      this.selectedTIF = this.prepareExists.timeInForce;
      this.selectedPrice = this.prepareExists.price;
      this.selectedType = this.prepareExists.tradeType;
      this.checklist = this.prepareExists.checklist;
    } else {
      if (this.history.length > 0) {
        this.selectedSymbol = this.history[0].symbol;
        this.selectedStrategy = this.history[0]._strategy;
        this.selectedTIF = this.history[0].timeInForce;
        this.selectedPrice = this.history[0].price;
        this.selectedType = this.history[0].tradeType;
      }
    }

    this.updateTimes();
    setInterval(() => {
      if (this.freeze) {
        this.countDown--;
        if (this.countDown <= 0) this.countDown = 0;
      }
      this.updateTimes();
    }, 1000);

    //if(this.prepareExists)
    this.$emit("loading", false);
  },

  methods: {
    getCurrent() {
      return new Promise(resolve => {
        axios
          .post("https://tradeinpool.com:3001/api/request/TradePreparation/", {
            method: "current"
          })
          .then(response => {
            if (response.data) this.prepareExists = response.data;
            resolve();
          });
      });
    },
    getHistory() {
      return new Promise(resolve => {
        axios
          .post("https://tradeinpool.com:3001/api/request/TradePreparation/", {
            method: "list"
          })
          .then(response => {
            this.history = response.data;
            resolve();
          });
      });
    },
    getStrategies() {
      return new Promise(resolve => {
        axios
          .post("https://tradeinpool.com:3001/api/request/strategies/", {
            method: "listBasic"
          })
          .then(response => {
            if (response) {
              this.userStrategies = response.data;
              resolve();
            }
          });
      });
    },
    getTags() {
      return new Promise(resolve => {
        axios
          .post("https://tradeinpool.com:3001/api/request/tags/", {
            method: "listBasic"
          })
          .then(response => {
            if (response) {
              this.userTags = response.data;
              this.filteredTags = response.data;
              resolve();
            }
          });
      });
    },
    getMarkets() {
      return new Promise(resolve => {
        axios
          .post("https://tradeinpool.com:3001/api/request/markets/", {
            method: "list"
          })
          .then(response => {
            if (response) {
              this.userMarkets = response.data;
              resolve();
            }
          });
      });
    },
    selectChecklist(index) {
      var oldObject = this.checklist[index];
      if (oldObject.selected == true) {
        oldObject.selected = false;
        //this.$set(this.checklist, index, oldObject);
      } else {
        oldObject.selected = true;
        //this.$set(this.checklist, index, oldObject);
      }

      if (this.prepareExists) {
        var prepareData = {
          method: "update",
          id: this.prepareExists._id,
          key: "checklist",
          new: this.checklist
        };
        axios
          .post(
            "https://tradeinpool.com:3001/api/update/TradePreparation/",
            prepareData
          )
          .then(() => {
            this.$set(this.checklist, index, oldObject);
          });
      } else {
        this.$set(this.checklist, index, oldObject);
      }
    },
    closePrepare(method) {
      this.$emit("loading", true);
      var prepareData = {
        method: method
      };
      axios
        .post(
          "https://tradeinpool.com:3001/api/update/TradePreparation/",
          prepareData
        )
        .then(response => {
          this.selectedTags = null;
          this.prepareExists = null;
          if (this.checklist) {
            this.checklist.forEach(check => {
              check.selected = false;
            });
          }
          this.history.unshift(response.data);
          if (this.history.length > 5) this.history.pop();
          this.$emit("loading", false);
        });
    },
    newPrepare() {
      this.$emit("loading", true);

      if (this.checklist == null) this.checklist = [];
      var prepareData = {
        method: "new",
        data: {
          timeInForce: this.selectedTIF,
          price: this.selectedPrice,
          symbol: this.selectedSymbol,
          tradeType: this.selectedType,
          tags: this.selectedTags,
          _strategy: this.selectedStrategy,
          checklist: this.checklist
        }
      };

      axios
        .post(
          "https://tradeinpool.com:3001/api/update/TradePreparation/",
          prepareData
        )
        .then(() => {
          // if(this.description || this.images.length > 0)
          // this.upload()
          // else
          this.getCurrent();
          this.freeze = false;
          this.$emit("loading", false);
        });
    },
    updateTimes() {
      if (this.prepareExists) {
        if (this.selectedTIF != "Till Cancel") {
          let start = moment(); // some random moment in time (in ms)
          let end = moment(this.prepareExists.expiry); // some random moment after start (in ms)
          let diff = end.diff(start);

          if (diff <= 0) {
            this.remain = "expired";
            this.closePrepare("expired");
          } else this.remain = moment.utc(diff).format("HH:mm:ss");
        } else {
          this.remain = "Until Cancel";
        }
      }
    },
    imgData(data) {
      this.images = data;
    },
    textData(data) {
      this.description = data;
    },
    upload() {
      this.uploading = true;
      //IF IMAGES INCLUDED
      let formData = new FormData();
      formData.append("parentType", "Prepares");
      formData.append("description", this.description);
      formData.append("parentId", null);
      this.images.forEach(fileItem => {
        formData.append("img", fileItem);
      });
      axios
        .post("https://tradeinpool.com:3001/api/update/preparetext/", formData)
        .then(response => {
          this.prepareExists.description = response.data.description;
          this.prepareExists._images = response.data._images;
          this.uploading = false;
          this.getCurrent();
        });
    }
  },
  sockets: {
    PREPARE_CLOSE: function(data) {
      if (data._creator == this.$store.state.userData._id) {
        this.selectedTags = null;
        this.prepareExists = null;
        if (this.checklist) {
          this.checklist.forEach(check => {
            check.selected = false;
          });
        }
        this.history.unshift(data);
        if (this.history.length > 5) this.history.pop();
        //alert(data)
      }
    },
    PREPARE_PRECLOSE: function(data) {
      if (data == this.$store.state.userData._id) {
        (this.freeze = true), (this.countDown = 10);
      }
    }
  }
};
</script>







<style scoped>
.minwidth {
  width: 50%;
  float: left;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.history {
  width: 100%;
  float: left;
}
.descInput input[type="text"] {
  margin-right: 15px;
  height: 30px;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #404855;
  color: white;
  font-size: 12px;
  margin-top: 15px;
}

*:focus {
  outline: none;
}

.short {
  color: #e62163;
  font-weight: bold;
}

.long {
  color: #79c04d;
  font-weight: bold;
}
.my-row {
  width: 48%;
  float: left;
}
.my-row-small {
  width: 150px;
  float: right;
}

.inpmargin-left {
  margin-left: 2%;
}
.inpmargin-top {
  margin-top: 10px;
}
.inpmargin-right {
  margin-right: 2%;
}

.descpInput {
  float: left;
  width: 100%;
}

.descpInput input[type="text"] {
  height: 30px;
  border-radius: 3px;
  background-color: #404855;
  color: white;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  padding-left: 13px;
}

.pre-trade {
  width: 100%;
  float: left;
  background: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  font-size: 12px;
}

.head-main {
  color: #4dbac0;
}
.prepare-action {
  float: right;
  color: white;
}
.smaller {
  height: 30px;
}
.head-content {
  float: left;
}

.head-content2 {
  float: right;
  padding-top: 2px;
}

.prep-body {
  float: left;
  width: 100%;
}

.div-table {
  display: table;
  width: auto;
  border-spacing: 5px; /* cellspacing:poor IE support for  this */
}
.div-table-row {
  display: table-row;
  width: auto;
  clear: both;
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;
}

.noteInput input[type="text"] {
  margin-right: 15px;
  height: 30px;
  border-radius: 15px;
  border: 0px;
  padding-left: 21px;
  background-color: #404855;
  color: white;
  font-size: 12px;
}

.my-inputs {
  background-color: #404855;
  border: 0px;
  color: white;
  border-radius: 3px;
  font-weight: bold;
}
.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
::-moz-selection {
  background: transparent;
}
::selection {
  background: transparent;
}

.select_box {
  float: left;
  background-color: #404855;
  border-radius: 3px;
  overflow: hidden;
  border: 0px;
  position: relative;
}
.input_box {
  float: left;
  background-color: #404855;
  border-radius: 3px;
  overflow: hidden;
  border: 0px;
  position: relative;
  font-size: 12px;
  padding: 6px;
}

.select_box:after {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
  position: absolute;
  top: 40%;
  right: 10px;
  content: "";
  z-index: 98;
}
.select_box select {
  border: 0;
  position: relative;
  z-index: 99;
  background: none;
  font-size: 12px;
}
.margined-r {
  margin-right: 10px;
}

div.v-select-list div[role="list"] div[role="listitem"]:hover {
  background-color: #00857a;
}
</style>
